import { SUPPORT_OPTION } from "../constants/Constants";

class SupportOption {
    isAppOnly(joinMeetingData) {
        return joinMeetingData?.sessionConfigurations?.SMSSUPPORTOPTION == SUPPORT_OPTION.APP_ONLY;
    }

    isAskUser(joinMeetingData) {
        return joinMeetingData?.sessionConfigurations?.SMSSUPPORTOPTION == SUPPORT_OPTION.ASK_USER;
    }

    isBrowserFirst(joinMeetingData) {
        return joinMeetingData?.sessionConfigurations?.SMSSUPPORTOPTION == SUPPORT_OPTION.BROWSER_FIRST;
    }

    isBrowserOnly(joinMeetingData) {
        return joinMeetingData?.sessionConfigurations?.SMSSUPPORTOPTION == SUPPORT_OPTION.BROWSER_ONLY;
    }
}
export default new SupportOption();
